import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-indigo-900 to-violet-900 text-white px-5 py-5 md:px-[20px] md:py-[20px] font-sans">
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-8 md:gap-10 mb-2.5">
        <div className="flex flex-col">
          <h3 className="text-[1.8em] mb-4 font-bold text-white">Kids Work</h3>
          <p className="text-base leading-[1.8] text-indigo-100 m-0">
            Dedicated to helping children with special needs grow, learn, and live confidently.<br/>
            Our Mission : "To help every child learn, grow, and thrive at their own pace."
          </p>
        </div>

        <div className="flex flex-col">
          <h4 className="text-[1.2em] mb-2.5 font-semibold text-indigo-200">Quick Links</h4>
          <ul className="list-none p-0 m-0">
            <li className="mb-2.5"><Link to="/" className="text-indigo-100 no-underline text-base transition-all duration-300 inline-block hover:text-white hover:translate-x-[5px] hover:underline">Home</Link></li>
            <li className="mb-2.5"><Link to="/branches" className="text-indigo-100 no-underline text-base transition-all duration-300 inline-block hover:text-white hover:translate-x-[5px] hover:underline">Our Branches</Link></li>

            <li className="mb-2.5"><Link to="/gallery" className="text-indigo-100 no-underline text-base transition-all duration-300 inline-block hover:text-white hover:translate-x-[5px] hover:underline">Gallery</Link></li>
            <li className="mb-2.5"><Link to="/blog" className="text-indigo-100 no-underline text-base transition-all duration-300 inline-block hover:text-white hover:translate-x-[5px] hover:underline">Blog</Link></li>
            <li className="mb-2.5"><Link to="/book-online" className="text-indigo-100 no-underline text-base transition-all duration-300 inline-block hover:text-white hover:translate-x-[5px] hover:underline">Book Online</Link></li>
            <li className="mb-2.5"><Link to="/contact" className="text-indigo-100 no-underline text-base transition-all duration-300 inline-block hover:text-white hover:translate-x-[5px] hover:underline">Contact Us</Link></li>
            <li className="mb-2.5"><Link to="/about" className="text-indigo-100 no-underline text-base transition-all duration-300 inline-block hover:text-white hover:translate-x-[5px] hover:underline">About</Link></li>
          </ul>
        </div>

        <div className="flex flex-col">
          <h4 className="text-[1.2em] mb-2.5 font-semibold text-indigo-200">Contact</h4>
          <p className="text-base leading-[1.8] text-indigo-100 m-0">
            Muzaffarpur, Bihar : <br/>
            Add.1- Mehta Compound, Near Simna Internationl Hotel
            Power House Chowk(842003)<br />
            Add.2- New Sikanderpur Road, Near Gupta Timber
            Akharaghat(842001) <br/>
            Mob.: 7727043497, 8797681753<br />
            <br />
            Sitamarhi, Bihar : <br/>
            Add.1- Shanti Nagar, Near ITI College, RCM Gali, Dumra(843301)<br />
            Mob.: 7727043497, 8797681753
          </p>
        </div>
      </div>

      <div className="border-t border-indigo-800 pt-2.5 text-center text-indigo-300 text-[0.9em]">
        <p>&copy; {new Date().getFullYear()} Kids Work Rehabilitation Center. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

